import { makeStyles } from '@mui/styles';
import MenuItem from 'apollo-react/components/MenuItem';
import Select from 'apollo-react/components/Select';
import React from 'react';

import { DEFAULT_SELECT_VALUE, INPUT_MAX_HEIGHT } from '../constants';

const useStyles = makeStyles({
  root: {
    marginTop: 0,
    width: 60,
  },
  input: {
    maxHeight: INPUT_MAX_HEIGHT,
    minHeight: 0,
  },
  menuItem: {
    maxHeight: INPUT_MAX_HEIGHT,
  },
});

const GroupSelect = ({ groupType, value, onChange, showLabel, disabled, ...props }) => {
  const classes = useStyles();

  return (
    <Select
      {...props}
      className={classes.root}
      InputProps={{
        inputProps: {
          className: classes.input,
        },
      }}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      label={showLabel ? groupType : null}
    >
      <MenuItem className={classes.menuItem} value={DEFAULT_SELECT_VALUE} />
      <MenuItem className={classes.menuItem} value={groupType}>
        {groupType}
      </MenuItem>
    </Select>
  );
};

export default GroupSelect;
